import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import blogs from '../configs/blogData';
import '../styles/BlogDetails.css';

const BlogDetails = () => {
  const { url } = useParams();
  const blog = blogs.find((b) => b.url === url);
  const baseUrl = 'https://jermingo.com';

  useEffect(() => {
    if (blog) {
      document.title = `${blog.title} | Jermingo`;
      let metaDesc = document.querySelector('meta[name="description"]');
      if (!metaDesc) {
        metaDesc = document.createElement('meta');
        metaDesc.setAttribute('name', 'description');
        document.head.appendChild(metaDesc);
      }
      metaDesc.setAttribute('content', blog.excerpt);
      let canonical = document.querySelector('link[rel="canonical"]');
      if (!canonical) {
        canonical = document.createElement('link');
        canonical.setAttribute('rel', 'canonical');
        document.head.appendChild(canonical);
      }
      canonical.setAttribute('href', `${baseUrl}/blog/${blog.url}`);
    }
  }, [blog]);

  if (!blog) {
    return <h1>Blog not found</h1>;
  }

  const imageSrc = `/images/blog/${blog.img}`;
  const currentIndex = blogs.findIndex((b) => b.url === url);
  const relatedPosts = blogs
    .filter((_, i) => i !== currentIndex)
    .slice(0, 3);

  // Strip leading indentation so markdown renders as headings/paragraphs instead of a code block
  const stripIndent = (str) => {
    const lines = str.split('\n');
    const nonEmpty = lines.filter((l) => l.trim().length > 0);
    if (nonEmpty.length === 0) return str;
    const minIndent = Math.min(...nonEmpty.map((l) => (l.match(/^[ \t]*/) || [''])[0].length));
    return lines.map((l) => l.slice(minIndent)).join('\n');
  };
  const normalizedBody = stripIndent(blog.body);

  return (
    <div className="blog-details-container">
      <h1 className="blog-title">{blog.title}</h1>
      <div className="blog-meta">
        <span className="blog-date">{new Date(blog.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</span>
        {blog.author && <span className="blog-author">By {blog.author}</span>}
      </div>
      <div className="blog-image-container">
        <img src={imageSrc} alt={blog.title} className="blog-image" />
      </div>
      <div className="blog-body-container markdown-body">
        <ReactMarkdown>{normalizedBody}</ReactMarkdown>
      </div>
      {relatedPosts.length > 0 && (
        <div className="related-posts">
          <h2>Related Posts</h2>
          <ul>
            {relatedPosts.map((post) => (
              <li key={post.url}>
                <Link to={`/blog/${post.url}`}>{post.title}</Link>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default BlogDetails;